<template>
  <HeaderVue :isAuthenticated="false" />
  <main class="public-layout_main">
    <router-view />
  </main>
  <FooterVue />
  <notifications position="top right" />
</template>

<script>
import HeaderVue from '@/components/common/Header.vue'
import FooterVue from '@/components/common/Footer.vue'

export default {
  name: 'public-layout',
  components: {
    HeaderVue,
    FooterVue,
  },
}
</script>

<style scoped>
.public-layout_main {
  min-height: calc(100vh - 132px);
  background: var(--color-main-white);
}
</style>
